import $ from "jquery";

var loaderMaskCnt = 0;

var toggleLoadingMask = function ($element, toggle) {
  var maskId = $element.data("loaderMaskId"),
    $mask = maskId ? ($mask = $("#" + maskId)) : null,
    support = window.kendo.support,
    browser = support.browser,
    isRtl,
    leftRight,
    webkitCorrection,
    containerScrollLeft,
    elOffset;
  if ($mask && toggle) {
    $mask.data("cnt", $mask.data("cnt") + 1);
  } else if (!$mask && toggle) {
    isRtl = support.isRtl($element);
    leftRight = isRtl ? "right" : "left";
    containerScrollLeft = $element.scrollLeft();
    elOffset = $element.offset();

    webkitCorrection = browser.webkit
      ? !isRtl
        ? 0
        : $element[0].scrollWidth - $element.width() - 2 * containerScrollLeft
      : 0;

    $mask = $(
      "<div class='k-loading-mask'>" +
        "<span class='k-loading-text'>Loading...</span>" +
        "<div class='k-loading-image'></div>" +
        "<div class='k-loading-color'</div>" +
        "</div>"
    )
      .width($element.outerWidth(true))
      .height($element.outerHeight(true))
      .css("top", $element.scrollTop() + elOffset.top)
      .css(
        leftRight,
        Math.abs(containerScrollLeft) + webkitCorrection + elOffset.left
      )
      .appendTo($("body"))
      .data("cnt", 1)
      .attr("id", "loader-mask-" + loaderMaskCnt);

    var timer = setInterval(function () {
      if (!$.contains(document.documentElement, $element[0])) {
        $mask.remove();
      }
      if (!$.contains(document.documentElement, $mask[0])) {
        clearInterval(timer);
      }
    }, 500);
    $element.data("loaderMaskId", "loader-mask-" + loaderMaskCnt++);
  } else if ($mask) {
    $mask.data("cnt", $mask.data("cnt") - 1);
    if (!$mask.data("cnt")) {
      $mask.remove();
      $element.data("loaderMaskId", "");
    }
  }
};

export default toggleLoadingMask;
